import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpPasswordConfirm', pkpPasswordConfirm);

    /**
     * Validates 2 password or emails on whether or not they are the same.
     * @ngInject
     */
    function pkpPasswordConfirm() {
        return {
            require: 'ngModel',
            scope: {
                comparedValue: '=pkpPasswordConfirm'
            },
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.pkpConfirm = function (modelValue) {
                    return modelValue === scope.comparedValue;
                };
                scope.$watch('comparedValue', function () {
                    ngModel.$validate();
                });
            }
        };
    }
})();
